import { render, staticRenderFns } from "./ModalVerDetalleCuadratura.vue?vue&type=template&id=6b1fe66c&scoped=true&"
import script from "./ModalVerDetalleCuadratura.vue?vue&type=script&lang=ts&"
export * from "./ModalVerDetalleCuadratura.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerDetalleCuadratura.vue?vue&type=style&index=0&id=6b1fe66c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1fe66c",
  null
  
)

export default component.exports